var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 13H18l-7 11 7 11h12l7-11zm-6 16c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 7.2c-.5-.7-1.3-1.2-2.198-1.2H15.398C14.5 6 13.7 6.5 13.2 7.2l-5.8 9.5L12 24l6.3-10h20.598zM16 11c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1zm16 0c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 34L7.399 16.8l-3.597 5.9c-.5.8-.5 1.902 0 2.698l9.398 15.403C13.7 41.6 14.5 42 15.4 42H24.5l5.102-8zM8 25c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1zm8 14c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.398 16.8L12 24l2.398-3.7L8.5 15z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.602 42l5.097-8h-4.8l-2.297 8z",
    fill: "#F9A825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 22.7L38.897 14H29.7L36 24 24.602 42h8c.898 0 1.699-.5 2.199-1.2l9.5-15.402c.5-.898.5-1.898-.102-2.699zM32 39c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1zm8-14c-.602 0-1-.398-1-1s.398-1 1-1 1 .398 1 1-.398 1-1 1z",
    fill: "#DD2C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.898 14H29.7l2.5 3.898L40.102 16z",
    fill: "#BF360C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.d3bb457dd7cc8be8e1655a4d5e48e1b9.svg";
export { ForwardRef as ReactComponent };